// ##### 25-02-05 Komarov
import { Input } from 'antd';
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../../../../hooks/useLocalizedText.js';

// ##### Komarov 2025-07-14
const BusTransferComponent = ({ props }) => {
  const { maxLength, AddBusTransferComments, busTransferComments } = props;
  // ##### Komarov 2025-08-05
  const busTransferCommentsMessage = useLocalizedText('Bus Transfer');
  // ##### 23-10-17 Komarov
  const { TextArea } = Input;

  return (
    <div key={uniqueId()} className="form-block-lf">
      <span>{busTransferCommentsMessage}</span>
      <TextArea
        rows={1}
        maxLength={maxLength}
        style={{ marginTop: '0.5vh', marginBottom: '0.5vh' }}
        onChange={AddBusTransferComments}
        value={busTransferComments}
      />
    </div>
  );
};

// ##### 25-05-21 Komarov
export default BusTransferComponent;
